import React from 'react'
import { ActionButton } from '../style'

const RoleStatus = ({ jobRolePreviewData, isLoading }) => {
  const roleStatus =
    jobRolePreviewData?.jobRoleInstituteMap?.length > 0
      ? jobRolePreviewData?.jobRoleInstituteMap[0]?.roleStatus
      : ''
  let color
  let bgcolor
  let status
  if (roleStatus == 'ROLE_CLOSED') {
    color = '#000000'
    bgcolor = '#ffffff'
    status = 'Role cancelled'
  } else if (roleStatus == 'EVALUATION_IN_PROGRESS') {
    color = '#F7B400'
    bgcolor = '#FFF8E6'
    status = 'Evaluation in-progress'
  } else if (roleStatus == 'OPEN_FOR_APPLICATION') {
    color = '#3249D7'
    bgcolor = 'rgb(179 176 243);'
    status = 'Open for applications'
  } else if (roleStatus == 'APPLICATION_CLOSED') {
    color = '#000000'
    bgcolor = '#ffffff'
    status = 'Application closed'
  } else if (roleStatus == 'COMPLETED') {
    color = '#0FB680'
    bgcolor = '#A1F2D8'
    status = 'Completed'
  } else if (roleStatus == 'UPCOMING') {
    color = '#000000'
    bgcolor = '#ffffff'
    status = 'Upcoming'
  } else if (roleStatus == 'DRAFT') {
    color = '#B4B4B4'
    bgcolor = '#F0F0F9'
    status = 'Draft'
  } else {
    status = 'Yet to Update'
  }

  return (
    <>
      {!isLoading && (
      <div style={{ fontSize: '14px' }}>
      Status: <b style={{ fontSize: '15px' }}>{status}</b>
    </div>
    )}
    </>
  )
}
export default RoleStatus
